var _circle, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_27168_8813)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27168_8813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27168_8813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9577C21.4577 16.9577 22.9253 16.7465 24.403 16.324C25.8805 15.9017 26.7366 15.4622 26.9712 15.0057C26.7429 14.5161 25.8958 14.0593 24.4298 13.6355C22.9638 13.2118 21.4872 13 20 13C18.5153 13 17.0438 13.2061 15.5855 13.6182C14.1272 14.0304 13.2685 14.4801 13.0095 14.9673C13.2622 15.4366 14.1144 15.8857 15.5662 16.3145C17.0182 16.7433 18.4962 16.9577 20 16.9577ZM25.4615 28.702H26.3462V24.602L28.1462 26.402L28.7693 25.7788L25.9038 22.9135L23.0385 25.7788L23.6615 26.402L25.4615 24.602V28.702ZM22.7172 28.9943C21.8418 28.1186 21.404 27.0564 21.404 25.8077C21.404 24.5589 21.8418 23.4967 22.7172 22.6213C23.5929 21.7456 24.6551 21.3077 25.9038 21.3077C27.1526 21.3077 28.2148 21.7456 29.0903 22.6213C29.9659 23.4967 30.4038 24.5589 30.4038 25.8077C30.4038 27.0564 29.9659 28.1186 29.0903 28.9943C28.2148 29.8699 27.1526 30.3078 25.9038 30.3078C24.6551 30.3078 23.5929 29.8699 22.7172 28.9943ZM19.325 26.9845C19.3687 27.2615 19.4293 27.5234 19.5068 27.7703C19.5843 28.0169 19.6756 28.2602 19.7808 28.5C18.5961 28.4897 17.5013 28.3906 16.4963 28.2027C15.4911 28.0149 14.6177 27.7611 13.876 27.4413C13.1343 27.1214 12.5529 26.7448 12.1318 26.3115C11.7106 25.8782 11.5 25.4089 11.5 24.9038V15C11.5 14.0347 12.3295 13.21 13.9885 12.526C15.6475 11.842 17.6513 11.5 20 11.5C22.3487 11.5 24.3525 11.842 26.0115 12.526C27.6705 13.21 28.5 14.0347 28.5 15V19.6463C28.2602 19.5411 28.0169 19.4529 27.7703 19.3817C27.5234 19.3106 27.2667 19.2533 27 19.2098V16.9C26.159 17.3897 25.1305 17.7659 23.9145 18.0288C22.6985 18.2916 21.3937 18.4198 20 18.4135C18.5705 18.4135 17.2509 18.2821 16.0412 18.0193C14.8317 17.7564 13.818 17.3833 13 16.9V20.1558C13.818 20.8238 14.8702 21.2917 16.1567 21.5595C17.4432 21.8275 18.7243 21.9615 20 21.9615H20.4385C20.2732 22.191 20.1289 22.4292 20.0058 22.676C19.8828 22.9227 19.7725 23.1845 19.675 23.4615C18.4532 23.4268 17.2478 23.2935 16.0588 23.0615C14.8696 22.8295 13.85 22.4583 13 21.948V25C13.1487 25.2487 13.4179 25.4903 13.8077 25.725C14.1974 25.9597 14.6721 26.1628 15.2317 26.3345C15.7914 26.5063 16.4216 26.65 17.1223 26.7655C17.8228 26.8808 18.557 26.9538 19.325 26.9845Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27168_8813",
    x1: 1.86264e-7,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#2A5636"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.75e9e0aa21e3d55ac326915f9a99a07d.svg";
export { ForwardRef as ReactComponent };